import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/protectedRoute";
import Layout from "./components/Layout";
import Login from "./components/login";
import Logout from "./components/logout";
import Settings from "./components/settings";
import UserManagement from "./components/user-management";
import User from "./components/user-management/user";
import Roles from "./components/user-management/roles";
import Role from "./components/user-management/roles/role";
import Permissions from "./components/user-management/permissions";
import Permission from "./components/user-management/permissions/permission";
import FormManagement from "./components/form-management";
import Form from "./components/form-management/form";
import PackageManagement from "./components/package-management";
import Package from "./components/package-management/package";
import EmailTemplateManagement from "./components/email-template-management";
import EmailTemplate from "./components/email-template-management/email-template";
import PatientDashbaord from "./components/patient-dashboard";
import ApplicationManagement from "./components/application-management";
import ApplicationForm from "./components/application-management/application-form";
import LocationManagement from "./components/location-management";
import Location from "./components/location-management/location";
import ExportForm from "./components/export-form";
import ExportAll from "./components/export-all";
import StaffScreening from "./components/staff-screening";
import ResetPassword from "./components/reset-password";
import COVIDRapidTest from "./components/covid-rapid-test";

const App = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/reset-password"
        element={
          <ProtectedRoute>
            <ResetPassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/application-management"
        element={
          <ProtectedRoute>
            <ApplicationManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/application-form/:userId/:packageId/:id"
        element={
          <ProtectedRoute>
            <ApplicationForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/export-form/:userId/:packageId/:id/:readOnly"
        element={
          <ProtectedRoute>
            <ExportForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/export-all/:userId/:packageId"
        element={
          <ProtectedRoute>
            <ExportAll />
          </ProtectedRoute>
        }
      />
      <Route
        path="/patient-dashboard"
        element={
          <ProtectedRoute>
            <PatientDashbaord />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user-management"
        element={
          <ProtectedRoute>
            <UserManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/user/:id"
        element={
          <ProtectedRoute>
            <User />
          </ProtectedRoute>
        }
      />
      <Route
        path="/form-management"
        element={
          <ProtectedRoute>
            <FormManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/form/:id"
        element={
          <ProtectedRoute>
            <Form />
          </ProtectedRoute>
        }
      />
      <Route
        path="/email-template-management"
        element={
          <ProtectedRoute>
            <EmailTemplateManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/email-template/:id"
        element={
          <ProtectedRoute>
            <EmailTemplate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/roles"
        element={
          <ProtectedRoute>
            <Roles />
          </ProtectedRoute>
        }
      />
      <Route
        path="/role/:id"
        element={
          <ProtectedRoute>
            <Role />
          </ProtectedRoute>
        }
      />
      <Route
        path="/permissions"
        element={
          <ProtectedRoute>
            <Permissions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/permission/:id"
        element={
          <ProtectedRoute>
            <Permission />
          </ProtectedRoute>
        }
      />
      <Route
        path="/package-management"
        element={
          <ProtectedRoute>
            <PackageManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/package/:id"
        element={
          <ProtectedRoute>
            <Package />
          </ProtectedRoute>
        }
      />
      <Route
        path="/location-management"
        element={
          <ProtectedRoute>
            <LocationManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/location/:id"
        element={
          <ProtectedRoute>
            <Location />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />
      <Route path="/logout" element={<Logout />} />
      <Route path="/staff-screening" element={<StaffScreening />} />
      <Route path="/covid-rapid-test" element={<COVIDRapidTest />} />
    </Routes>
  </Layout>
);

export default App;
